import React, { useState } from 'react';
import moment from 'moment';
import { useQueryClient } from 'react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import '../styles/RefreshControl.css';

/**
 * Refresh, and when the page last did.
 *
 * Both the water dashboard and the meter details page carried their own copy,
 * and both had the same fault: the handler refetched the record the page was
 * built around — the meters list, or the meter itself — while every figure on
 * screen came from a separate query cached for five minutes. Pressing refresh
 * moved the timestamp and left the numbers alone, which told the reader they
 * were current when they were not.
 *
 * The control owns that now, so a page cannot wire it up wrongly.
 */

/** Key prefix every card and chart query is stored under. */
export const GRAPH_QUERY_KEY = 'graphData';

/**
 * @param {Function} onRefresh - Anything else the page wants refetched, such
 *   as the record its header is drawn from.
 */
const RefreshControl = ({ onRefresh }) => {
  const queryClient = useQueryClient();
  const [refreshedAt, setRefreshedAt] = useState(() => moment());

  const handleRefresh = () => {
    queryClient.invalidateQueries(GRAPH_QUERY_KEY);
    onRefresh?.();
    setRefreshedAt(moment());
  };

  return (
    <div className="im-refresh">
      <button
        type="button"
        className="im-refresh-btn"
        onClick={handleRefresh}
        title="Refresh every figure on this page"
      >
        <FontAwesomeIcon icon={faSync} />
        Refresh
      </button>
      <span className="im-refresh-at">
        Last updated: {refreshedAt.format('HH:mm:ss')}
      </span>
    </div>
  );
};

export default RefreshControl;
